export const externalLinks = {
	twitter: "https://twitter.com/bolaopenacova",
	bluesky: "https://bsky.app/profile/bolaopenacova.com",
	facebook: "https://www.facebook.com/BolaoPeNaCova",
	statistics: "https://estatisticas.bolaopenacova.com",
};
